import { getLaunchDarklyFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'
import { NotificationChannel } from '../notification-channel'
import { NotificationChannelImpl } from './notification-channel'
import type { NotificationChannel as INotificationChannel } from './model'
import { ShellWebSocketNotificationHandlerFactory } from './shell-websocket-notification-handler'

export const createNotificationChannel = (externalUserKey: string): INotificationChannel => {
  if (getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_NOTIFICATION_CHANNEL_V2)) {
    const handlerFactory = new ShellWebSocketNotificationHandlerFactory()
    return new NotificationChannelImpl(handlerFactory.create, externalUserKey)
  }
  return new NotificationChannel(externalUserKey)
}
